import RootModel from "./rootModel";
import {INodeModel} from "@/shared/models/abstract/INodeModel";
import {EntityType} from "@/shared/models/entityType";

/**
 * Abstract base model for normal nodes.
 */
export default class NodeBaseModel extends RootModel implements INodeModel {
    private _groupId: any;
    private _isFavorite: boolean;

    constructor(entityType: EntityType, label: string) {
        super(entityType, label);
        this._groupId = null;
        this._isFavorite = false;
    }

    /**
     * Gets the id of the group, if any, this node sits in.
     */
    get groupId() {
        return this._groupId;
    }

    set groupId(value) {
        this._groupId = value;
        this.raisePropertyChanged("groupId");
    }

    static fromJson(json) {
        throw new Error("NodeBaseModel should not be deserialized, only derived classes.")
    }

    toJson() {
        const m: any = super.toJson();
        m.groupId = this.groupId;
        m.isFavorite=this.isFavorite;
        return m;
    }

    get isFavorite(): boolean {
        return this._isFavorite;
    }

    set isFavorite(value) {
        this._isFavorite = value;
        this.raisePropertyChanged("isFavorite");
    }
}
